DialogOrdenesAddCtrl.$inject = ['$log', '$scope', '$http', 'Orden', '$q'];
export default function DialogOrdenesAddCtrl($log, $scope, $http, Orden, $q) {
    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: true,
        add: false
    };

    vm.formDeshabilitado = true;
    vm.modoEdicion = false;
    vm.reparadores = null;
    vm.todos_reparadores = false;
    var promesaDatos = null;
    var ordenAux = null;

    vm.opcionesCerrada = [
        {label: StringUtils.ucfirst(Lang.choice('nombres.si', 1)), value: 1},
        {label: StringUtils.ucfirst(Lang.choice('nombres.no', 1)), value: 0}
    ];

    vm.mostrarAsignarTareas = Sigo.config['ordenes']['mostrar_asignar_tareas'];
    vm.editarFechaAsigManualmente = false;
    vm.fechaAsigCalculadaAutomaticamente = true;
    vm.tareas_ya_asignadas = false;

    function cargarDatosDefecto() {
        var fechaOrden = moment(); // Fecha actual
        vm.model.orden = {};
        vm.model.orden.fecha = fechaOrden.format('DD/MM/YYYY');
        vm.model.orden.cerrada = 0;
        vm.model.orden.fecha_asignacion_tareas = '';
        vm.fecha_asignacion_min = moment(new Date()).subtract(1, 'days').toDate();

        if (vm.mostrarAsignarTareas && isArrayAndNotEmpty(vm.tipos)) {
            var primerTipo = vm.tipos[0];
            vm.model.orden.tipoorden_id = primerTipo.id;
            vm.model.orden.asignar_tareas = isNumeric(primerTipo.dias_antelacion);
            vm.model.orden.fecha_asignacion_tareas = calcularFechaAsignacionTareas(fechaOrden, primerTipo);
            if (vm.model.orden.fecha_asignacion_tareas == '') {
                vm.editarFechaAsigManualmente = true;
                vm.fechaAsigCalculadaAutomaticamente = false;
            }
        }
    }

    vm.actualizaFechas = function () {
        var fechaOrden = moment(vm.model.orden.fecha, 'DD/MM/YYYY');

        if (fechaOrden.isValid()) {

            if (!vm.editarFechaAsigManualmente) {
                var tipo = vm.tipos.find(function (element) {
                    return element.id == vm.model.orden.tipoorden_id;
                });

                if (vm.mostrarAsignarTareas && issetAndNotEmpty(tipo)) vm.model.orden.fecha_asignacion_tareas = calcularFechaAsignacionTareas(fechaOrden, tipo);
            }
        }
    };

    vm.actualizaTipo = function () {
        if (!vm.modoEdicion) {
            var fechaOrden = moment(vm.model.orden.fecha, 'DD/MM/YYYY');

            if (fechaOrden.isValid()) {
                var tipo = vm.tipos.find(function (element) {
                    return element.id == vm.model.orden.tipoorden_id;
                });

                if (vm.mostrarAsignarTareas && issetAndNotEmpty(tipo)) vm.model.orden.fecha_asignacion_tareas = calcularFechaAsignacionTareas(fechaOrden, tipo);
                if (vm.model.orden.fecha_asignacion_tareas == '') {
                    vm.model.orden.asignar_tareas = false;
                    vm.editarFechaAsigManualmente = true;
                    vm.fechaAsigCalculadaAutomaticamente = false;
                } else {
                    vm.model.orden.asignar_tareas = true;
                    vm.editarFechaAsigManualmente = false;
                    vm.fechaAsigCalculadaAutomaticamente = true;
                }
            }
        }
    };

    function calcularFechaAsignacionTareas(fechaOrden, tipo) {
        if (isNumeric(tipo.dias_antelacion)) {
            var fechaAsigTar = fechaOrden.clone().subtract(tipo.dias_antelacion, 'days');

            if (isNumeric(tipo.hora_asignacion) && parseInt(tipo.hora_asignacion) > -1 && parseInt(tipo.hora_asignacion) < 24)
                fechaAsigTar = fechaAsigTar.hour(tipo.hora_asignacion);

            fechaAsigTar = fechaAsigTar.minute(0);
            return fechaAsigTar.format('DD/MM/YYYY HH:mm');
        }
        return '';
    }

    cargarDatos();

    function cargarDatos() {
        if (vm.model.ordenId) {
            vm.modoEdicion = true;
            vm.editarFechaAsigManualmente = true;
            vm.fechaAsigCalculadaAutomaticamente = false;
        }

        var promesas = [];

        if (vm.modoEdicion) promesas.push(cargarOrden(vm.model.ordenId));
        promesas.push(cargarEntidades());
        promesas.push(cargarTipos());
        promesaDatos = $q.all(promesas);

        promesaDatos.then(function () {
            if (vm.modoEdicion) {
                vm.model.orden = ordenAux;
                if (vm.model.orden)
                    vm.actualizarReparadores(vm.model.orden.entidad_reparadora_id);
                ordenAux = null;
                vm.tareas_ya_asignadas = vm.model.orden.tareas_asignadas;
            } else {
                cargarDatosDefecto();
            }
            vm.formDeshabilitado = false;
            vm.cargando.datos = false;
        });
    }

    function cargarOrden(ordenId) {
        var promesa = Orden.get({ordenId: ordenId}).$promise;
        promesa.then(function (data) {
            var fecha = moment(data.fecha, 'YYYY-MM-DD');
            data.fecha = fecha.format('DD/MM/YYYY');

            data.asignar_tareas = issetAndNotEmpty(data.fecha_asignacion_tareas);

            if (data.asignar_tareas) {
                var fechaAsigTar = moment(data.fecha_asignacion_tareas, 'YYYY-MM-DD HH:mm');
                data.fecha_asignacion_tareas = fechaAsigTar.format('DD/MM/YYYY HH:mm');
            }

            ordenAux = data;
        });
        return promesa;
    }

    vm.renderUsuario = function (usuario) {
        let text = usuario.code;
        if (usuario.first_name || usuario.last_name) {
            text += ' (';
            if (usuario.first_name)
                text += usuario.first_name;
            if (usuario.last_name)
                text += ' ' + usuario.last_name;
            text += ')';
        }

        return text;
    };

    vm.actualizarReparadores = function (entidadId) {
        vm.reparadores = null;

        let urlBase = `${Sigo.var.path}/api/v1/entidades/${entidadId}/usuarios`;
        if (vm.todos_reparadores) urlBase += '?all_rep=1';
        const promesa = $http.get(urlBase);
        promesa.then(function (data) {
            vm.reparadores = data.data;
        });
    };

    function cargarEntidades() {
        var urlBase = Sigo.var.path + '/api/v1' + '/entidades' + '/REPARADOR';
        var promesa = $http.get(urlBase);
        promesa.then(function (data) {
            vm.entidades = data.data.data;
        });
        return promesa;
    }

    function cargarTipos() {
        var url = Sigo.var.path + '/api/v1' + '/tipos-ordenes';
        var promesa = $http.get(url);
        promesa.then(function (data) {
            vm.tipos = data.data;
        });
        return promesa;
    }

    vm.anyadirOrden = anyadirOrden;

    function anyadirOrden(orden) {
        vm.formDeshabilitado = true;
        vm.cargando.add = true;
        var ordenNueva = orden;
        var fecha = moment(ordenNueva.fecha, 'DD/MM/YYYY');
        ordenNueva.fecha = fecha.format('YYYY-MM-DD');

        if (ordenNueva.asignar_tareas) {
            var fechaAsigTar = moment(ordenNueva.fecha_asignacion_tareas, 'DD/MM/YYYY HH:mm');
            ordenNueva.fecha_asignacion_tareas = fechaAsigTar.format('YYYY-MM-DD HH:mm');
        } else
            ordenNueva.fecha_asignacion_tareas = '';

        var promesa = Orden.save(ordenNueva).$promise;
        promesa.then(function (data) {
            vm.model = data;
            vm.model.orden = {};
            var mensaje = Lang.get('ordenes.mensaje_add_orden_ok');
            $.toast({loader: false, text: mensaje, icon: 'success', hideAfter: 5000});
            // Sigo.UI.Messages.open([mensaje], 0);
            vm.dialogHandler.close(data);
        }, function (err) {
            $log.error('Error');
        });
    }

    vm.editarOrden = editarOrden;

    function editarOrden(orden) {
        vm.formDeshabilitado = true;
        vm.cargando.add = true;
        var ordenNueva = orden;
        var fecha = moment(ordenNueva.fecha, 'DD/MM/YYYY');
        ordenNueva.fecha = fecha.format('YYYY-MM-DD');

        if (ordenNueva.asignar_tareas) {
            var fechaAsigTar = moment(ordenNueva.fecha_asignacion_tareas, 'DD/MM/YYYY HH:mm');
            ordenNueva.fecha_asignacion_tareas = fechaAsigTar.format('YYYY-MM-DD HH:mm');
        } else
            ordenNueva.fecha_asignacion_tareas = '';

        var promesa = Orden.update({ordenId: orden.id}, ordenNueva).$promise;
        promesa.then(function (data) {
            var mensaje = Lang.get('ordenes.mensaje_edit_orden_ok');
            $.toast({loader: false, text: mensaje, icon: 'success', hideAfter: 5000});
            // Sigo.UI.Messages.open([mensaje], 0);
            vm.dialogHandler.close(data);
        }, function (err) {
            $log.error(err);
            $log.error('Error');
        });
    }

    vm.submitOrden = function (orden, modoEdicion) {
        return (modoEdicion) ? editarOrden(orden) : anyadirOrden(orden);
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }

}